export const getAgeDescription = (age: string | number | undefined): string => {
  return age ? `${age} year old` : '';
};
